import { render, staticRenderFns } from "./SfBar.vue?vue&type=template&id=3978c74c"
import script from "./SfBar.vue?vue&type=script&lang=js"
export * from "./SfBar.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfBar.vue?vue&type=style&index=0&id=3978c74c&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "70dcb8f4"
  
)

export default component.exports